import React from 'react'
import { BsInstagram } from 'react-icons/bs'
import { FaFacebook, FaWhatsapp } from 'react-icons/fa'
import {FacebookShareButton,WhatsappShareButton} from "react-share";


export const ResultFooter = () => {

    const path = window.location.href
    console.log()
    

    return(
        <div className='items-center text-sm p-10 flex flex-col justify-center items-center'>
          <div>Compartilhe o programa usando 
            suas redes sociais e a hashtag <strong>#programaimpulso</strong>
          </div>
          <div className='w-full flex justify-center text-primary gap-1 mt-2 text-lg'>
          <FacebookShareButton 
                url={path}
                quote={""}
                hashtag="#programaimpulso"
                >
                 <FaFacebook />
              </FacebookShareButton>
              <WhatsappShareButton title="" separator='' url={path}>
                     <FaWhatsapp />
              </WhatsappShareButton>
              <BsInstagram />
          </div>
            
        </div>
    

    )
}